var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.aboutUs)?_c('BackgroundLayout',{scopedSlots:_vm._u([{key:"mainHeaderTitle",fn:function(){return [_vm._v(" "+_vm._s(_vm.aboutUs.title)+" ")]},proxy:true}],null,false,2695381377)},[_c('div',{class:`about-us-article`,domProps:{"innerHTML":_vm._s(_vm.aboutUs.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }